module.exports = __webpack_public_path__ + "src/assets/games/19/430.jpg";